module.exports = __webpack_public_path__ + "media/images/pipes-d3bce30d.jpg";